import { CreatePinboardMessageRequest, TargetAssociation } from './CreatePinboardMessageRequest';
import { GetPinboardMessageResponse } from './GetPinboardMessageResponse';
import { UpdatePinboardMessageRequest } from './UpdatePinboardMessageRequest';

export type PinboardMessageFormModel = {
    id: string;
    title: string;
    text: string;
    filePaths: string[];
    files?: File[] | undefined;
    canUserAnswer: string;
    target: string;
    targetAssociations?: string[];
};

export const mapResponseToForm = (pinboardMessage: GetPinboardMessageResponse): PinboardMessageFormModel => ({
    id: pinboardMessage.pinboardMessageId,
    title: pinboardMessage.title,
    text:
        pinboardMessage.text
            ?.replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<')
            .replace(/<br\s*\/?>/gm, '\n') || '',
    files: [],
    filePaths: pinboardMessage.filePaths ?? [],
    canUserAnswer: pinboardMessage.usersCanRespond ? 'ja' : 'nej',
    target: pinboardMessage.propertyAssociationArea?.propertyAssociationAreaId || 'all',
    targetAssociations: [],
});

export const mapFormToCreateRequest = (form: PinboardMessageFormModel, targetAssociations: TargetAssociation[]): CreatePinboardMessageRequest => ({
    files: form.files,
    isPinned: false,
    targetAssociations,
    text: form.text?.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br>') || '',
    title: form.title,
    usersCanRespond: form.canUserAnswer === 'ja',
});

export const mapFormToUpdateRequest = (form: PinboardMessageFormModel): UpdatePinboardMessageRequest => ({
    files: form.files,
    filePaths: form.filePaths,
    isPinned: false,
    text: form.text?.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br>') || '',
    title: form.title,
    usersCanRespond: form.canUserAnswer === 'ja',
});
